import React, { Component } from 'react';
import './AboutStyle.css'
import Card from './Card';

class AboutUsCardSet extends Component {
    render() {
        return (
            <section id="services">
                <div className="container" align="center">


                    <h1 className="text-center txt-main">Our Services</h1>

                    <div className="card-deck">
                        <Card topic="Plant Nursery" img={require('../../images/home/main.png')} />
                        <Card topic="Seeds" img={require('../../images/home/main.png')} />
                        <Card topic="Compost" img={require('../../images/home/main.png')} />
                    </div>
                </div>
            </section>



        );
    }
}

export default AboutUsCardSet;
